import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, GiftIcon } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CTA_LINK = 'https://www.mareaa.online/cart/53202441404781:1';
export function BonusesSection() {
  const bonuses = [{
    emoji: '🏃‍♀️',
    title: 'Rutina Anti-Inflamación',
    desc: 'Movimientos simples y efectivos para complementar tu proceso desde el primer día.'
  }, {
    emoji: '🥦',
    title: 'Lista Inteligente de Alimentos',
    desc: 'Sabé exactamente qué alimentos ayudan a desinflamarte y cuáles están saboteando tu progreso sin que lo notes.'
  }, {
    emoji: '⚡',
    title: 'Guía de Comidas Rápidas',
    desc: 'Recetas anti-inflamatorias para los días que no tenés tiempo. Sin excusas para saltearte el proceso.'
  }];
  return <section className="w-full bg-bg-softer py-16 px-4 md:px-8" data-id="element-17">
      <div className="max-w-3xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 25
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-19">
          <div className="inline-flex items-center gap-2 bg-bg-mint px-5 py-2 rounded-full mb-4" data-id="element-20">
            <GiftIcon className="w-5 h-5 text-accent" data-id="element-21" />
            <span className="text-accent font-semibold text-sm" data-id="element-22">
              BONOS GRATIS
            </span>
          </div>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-serif text-text-dark mb-2" data-id="element-23">
            🎁 HOY RECIBÍS TODO ESTO SIN PAGAR EXTRA
          </h2>
          <p className="text-primary-mid/70 text-sm" data-id="element-24">
            Hoy no solo recibís la guía… también estos bonos diseñados para
            acelerar tus resultados:
          </p>
        </motion.div>

        <div className="space-y-4 mb-8" data-id="element-25">
          {bonuses.map((b, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white p-6 rounded-xl border border-secondary/20 shadow-sm" data-id="element-26">
              <div className="flex items-start gap-4" data-id="element-27">
                <span className="text-2xl flex-shrink-0" data-id="element-28">{b.emoji}</span>
                <div data-id="element-29">
                  <div className="flex items-center gap-2 mb-1" data-id="element-30">
                    <h3 className="font-semibold text-text-dark" data-id="element-31">
                      BONO {i + 1} — {b.title}
                    </h3>
                  </div>
                  <p className="text-sm text-primary-mid/70" data-id="element-32">{b.desc}</p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <p className="text-center text-sm font-semibold text-accent mb-6" data-id="element-33">
          👉 Todo esto incluido HOY sin costo extra
        </p>

        <div className="text-center" data-id="element-34">
          <motion.a href={CTA_LINK} onClick={trackAddToCart} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center gap-3 bg-accent hover:bg-accent/90 text-white font-bold px-10 py-5 rounded-full shadow-lg shadow-accent/25 transition-all duration-300 text-base md:text-lg" data-id="element-35">
            QUIERO LA GUÍA + TODOS LOS BONOS
            <ArrowRightIcon className="w-5 h-5" data-id="element-36" />
          </motion.a>
        </div>
      </div>
    </section>;
}